import firebase from "firebase/compat/app";
import firebaseConfig from "./firebaseConfig";

import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";
import "firebase/compat/app-check";

if (process.env.NODE_ENV === "development")
  globalThis.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.VUE_APP_APPCHECK_DEBUG_TOKEN;

const firebaseApp = firebase.initializeApp(firebaseConfig);

try {
  firebase.appCheck().activate(
    new firebase.appCheck.ReCaptchaEnterpriseProvider(process.env.VUE_APP_APP_CHECK_PUBLIC_KEY),
    true,
  );
} catch (e) {
  console.error("Firebase App Check init failed:", e);
}

export default firebaseApp.firestore();
